import { WhatsappShareButton, TelegramShareButton } from 'react-share'
import {
  CommentIcon,
  DiscordIcon,
  HeartIcon,
  TelegramIcon,
  TiktokIcon,
  WhatsappIcon,
} from '../../ui/icons/shared'
import { articelsHomePageImages } from '../../../services/images.service'
import toast from 'react-hot-toast'
import { GreyBorderBottom } from '../../ui/elements'

export function PostEngagementPanel({ post, loggedInUser, onToggleLike }) {
  if (!post) return null

  const hasLiked = post.likes.includes(loggedInUser?._id)

  const handleCopyLink = async (platformName) => {
    await navigator.clipboard.writeText(window.location.href)
    toast.success(`קישור הועתק לשיתוף ב${platformName}!`)
  }

  return (
    <section
      className="hidden lg:block mt-6 w-[150px] mx-auto"
      aria-label="פאנל אינטראקציות עם הפוסט"
      role="complementary"
    >
      <div className="sticky top-[130px]">
        <div className="flex flex-col gap-4">
          <div
            className="flex gap-2 items-center text-p"
            aria-label="כמות תגובות"
          >
            <CommentIcon aria-hidden="true" />
            <p>{post.commentCount ?? 0}</p>
          </div>

          <div
            className="flex gap-2 items-center text-p"
            aria-label="כמות לייקים"
          >
            <HeartIcon
              onClick={onToggleLike}
              className={`cursor-pointer transition-colors duration-200 ${
                hasLiked ? 'text-primary' : 'hover:text-primary'
              }`}
              aria-label={hasLiked ? 'הסר לייק' : 'הוסף לייק'}
            />
            <p>{post.likes?.length || 0}</p>
          </div>

          <div>
            <h4 className="text-h4">שיתוף</h4>
            <GreyBorderBottom className="w-full" />
          </div>

          <div
            className="flex gap-4 items-center"
            role="group"
            aria-label="כפתורי שיתוף לרשתות חברתיות"
          >
            <WhatsappShareButton
              url={window.location.href}
              title={post.title}
              aria-label="שתף בוואטסאפ"
            >
              <WhatsappIcon className="text-primary w-6 h-6" />
            </WhatsappShareButton>

            <TelegramShareButton
              url={window.location.href}
              title={post.title}
              aria-label="שתף בטלגרם"
            >
              <TelegramIcon className="text-primary w-6 h-6" />
            </TelegramShareButton>

            <button
              onClick={() => handleCopyLink('טיקטוק')}
              aria-label="שתף בטיקטוק"
            >
              <TiktokIcon className="text-primary w-6 h-6" />
            </button>

            <button
              onClick={() => handleCopyLink('דיסקורד')}
              aria-label="שתף בדיסקורד"
            >
              <DiscordIcon className="text-primary w-6 h-6" />
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
